export function formatDuration(totalSeconds, { style = 'long', maxUnits = 5, daysPerMonth = 30 } = {}) {
  const s = Math.max(0, Math.floor(Number(totalSeconds) || 0));

  const SEC = 1;
  const MIN = 60 * SEC;
  const HOUR = 60 * MIN;
  const DAY = 24 * HOUR;
  const MONTH = daysPerMonth * DAY; // approximate months

  let rem = s;

  const parts = [['month', 'mo', Math.floor(rem / MONTH)]];
  rem %= MONTH;

  parts.push(['day', 'd', Math.floor(rem / DAY)]);
  rem %= DAY;

  parts.push(['hour', 'h', Math.floor(rem / HOUR)]);
  rem %= HOUR;

  parts.push(['minute', 'm', Math.floor(rem / MIN)]);
  rem %= MIN;

  parts.push(['second', 's', rem]);

  // Build output: drop zeros, cap units
  const nonZero = parts.filter(([, , val]) => val > 0);
  const used = (nonZero.length ? nonZero : [['second', 's', 0]]) // show "0 seconds" if all zero
    .slice(0, maxUnits);

  if (style === 'short') {
    // e.g., "1mo 2d 3h 4m 5s"
    return used.map(([_, short, val]) => `${val}${short}`).join(' ');
  }

  // long: e.g., "1 month 2 days, 3 hours and 4 minutes"
  const words = used.map(([long, _short, val]) => `${val} ${long}${val === 1 ? '' : 's'}`);
  if (words.length <= 1) return words[0];

  return words.slice(0, -1).join(', ') + ' and ' + words[words.length - 1];
}
